import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SeguimientoUserService } from '../../services/orden-proceso-services/seguimiento-user.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { PersonaService } from '../../services/general-services/persona.service';
import { Persona } from '../../models/persona';

@Component({
  selector: 'app-bitacora-seguimiento-perform',
  templateUrl: './bitacora-seguimiento-perform.component.html',
  styleUrls: ['./bitacora-seguimiento-perform.component.css']
})
export class BitacoraSeguimientoPerformComponent implements OnInit {

  formulario: FormGroup;
  diccionarioModulo: any;

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  columnDefs: any[];
  rowData: any[] = [];
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  frameworkComponents;

  loading: boolean = false;
  listaVacia: boolean = true;
  textoBuscar: string;

  usuariosList: Persona[] = [];

  titulo: string = "Reporte Log de Seguimiento con Filtros";

  constructor(private fb: FormBuilder,
    private _util: UtilsService,
    private _logServices : SeguimientoUserService,
    private _usuServices : PersonaService,
  )
    { }

  URI: string = 'REPORTE LOG SEGUIMIENTO';

  ngOnInit() {
    // this.servicioSeguimiento.saveSeguimiento(this.URI);
    this.diccionarioModulo = moduloPerform;

    this.DAT_BTNS = this.diccionarioModulo.button.buttonsNombre;
    this.DAT_MSG = this.diccionarioModulo.mensajes;
    this.DAT_BTNCSS = this.diccionarioModulo.button.buttonsCss;
    this.formulario = this.fb.group({
      numeroSemana: ['', [Validators.required]],
      usuario     : [''],
      fechaInicio : [''],
      fechaFin    : ['']
    });
    this.cargarGrid();
    this.formulario.get('numeroSemana').setValue(this._util.getNumberCurrentWeek());
    this.inicializarCombos();
    this.ejecutar();
  }

  /*------------FUNCIONES--------------------*/
  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'CEDULA',
        field: 'cedulaUser',
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'USUARIO',
        field: 'nombreUser',
        sortable: true,
        filter: true,
        width: 270
      },
      {
        headerName: 'MODULO',
        field: 'modulo',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'CANTIDAD',
        field: 'veces',
        sortable: true,
        filter: true,
        width: 150
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = "multiple";
  }

  /*------------SERVICIOS--------------------*/
  ejecutar() {
    this.listaVacia = true;
    this.loading = true;
    let numeroSemana = this.formulario.get('numeroSemana').value;
    let buscaUsuario = this.formulario.get('usuario').value;
    this._logServices.getAllSeguimientoPerform(numeroSemana, buscaUsuario).subscribe((res:any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0)? true: false;
    }, (err) => {
      this.rowData = [];
      this.listaVacia = true;
      this.loading = false;
      console.log(err);
    });
  }

  exportCSV(event) {
    if(this.rowData.length === 0){
      this._util.mensajeErroToast('No se encontraron registros para exportar.');
      return;
    }
    let listClone =  this.rowData.map((x) => Object.assign({}, x));
    const cabecera: any[] = [['CEDULA', 'USUARIO', 'NOMBRE USUARIO', 'MODULO', 'VECES']];
    let data: any[] = [];
    const name: string = "data.csv";
    listClone.forEach((e) => {
      data.push({
        cedulaUser: e.cedulaUser,
        nickUser: e.nickUser,
        nombreUser: e.nombreUser,
        modulo: e.modulo,
        veces: e.veces,
      });
    });
    this._util.exportCSV(cabecera, data, name);
    this._util.mensajeOKToast('Se realizó el proceso de exportación correctamente.');
  }

  habilitaFiltros: boolean = false;
  textoFiltros : String = "Filtrar por fechas";
  verFiltros(){
    this.habilitaFiltros = true;
    this.textoFiltros = "Filtrar por semana"
    this.formulario.reset();
    this.formulario.get('numeroSemana').setValue("0");
  }

  obtainDate(){
  }

  inicializarCombos(){
    this._usuServices.getAll().subscribe((res:any[]) => {
      this.usuariosList = res['respuesta'];
    }, (err) => {
      this.usuariosList = [];
      console.log(err);
    });
  }

}
